import React from 'react';

function getHeaderHeight() {
  const topSection = document.getElementById('topSectionTop');
  const bottomSection = document.getElementById('topSectionBottom');
  if (topSection && bottomSection) {
    return topSection.offsetHeight + bottomSection.offsetHeight;
  }

  return 0;
}

export function useHeaderHeight(): number {
  const [headerHeight, setHeaderHeight] = React.useState(0);

  React.useEffect(() => {
    function handleScroll() {
      setHeaderHeight(getHeaderHeight());
    };

    // Run this once to initialize value before scroll
    handleScroll();

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return headerHeight;
}